'use strict';

var GridPrintButtonDirective = function GridPrintButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-print-button.html'),
    controller: 'GridPrintButtonController'
  };
};
GridPrintButtonDirective.$inject = [];
module.exports = GridPrintButtonDirective;